import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../../config";
import useAxios from "../../../util/hooks/useAxios";
import { setCounter } from "../utils/utilSlice";
import { createAxiosInsatance } from "../../../util/helpers/createAxiosInsatance";
import { AccessPermissions, AppModules } from "../../../util/context";
import { IPermission } from "../../../interfaces";

const { API_URL } = config[process.env.NODE_ENV];

export const fetchAllPermissions = createAsyncThunk(
  "permissions/fetchAllPermissions",
  async (_, { getState, requestId, dispatch }) => {
    const thunkState = getState() as any;
    let api = createAxiosInsatance(thunkState.root.token, dispatch, setCounter);
    const { data } = await api!.post(
      `/api/Permission/All`,
      {
        where: {
          showFront: true,
        },
      },
      {
        headers: {
          "x-access-token": thunkState.root.token,
        },
      }
    );
    return data.data;
  }
);

const initialState = {
  permissionsList: [],
  loading: "idle",
  currentRequestId: undefined as any,
  error: null as any,
};

export const permissionsListSlice = createSlice({
  name: "permissionsList",
  initialState,
  reducers: {
    resetPermissionsList: (state: any) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPermissions.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
        }
      })
      .addCase(fetchAllPermissions.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.permissionsList = action.payload.filter((elt : IPermission) => elt.module !== AccessPermissions.Proscpects);
          state.currentRequestId = undefined;
        }
      })
      .addCase(fetchAllPermissions.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.error;
          state.currentRequestId = undefined;
        }
      });
  },
});

export const { resetPermissionsList } = permissionsListSlice.actions;
export default permissionsListSlice.reducer;
